import { BetCoefficientTypesEnum } from '@shared/constants';

import { BetOutcomeFormValues } from './types';

export const INITIAL_BET_OUTCOME_VALUES: BetOutcomeFormValues = {
  name: '',
  description: '',
  coefficientType: BetCoefficientTypesEnum.AUTO,
  coefficientValue: 1,
  maxBet: 5000,
};
